import { useCallback, type FC } from 'react'
import type { DefaultDataGridCells, RendererConfig, RenderProps } from '../types'

export const createRenderer = <Cell extends DefaultDataGridCells, TRow = object, TSummaryRow = unknown>(
  renderer: RendererConfig<Cell, TRow, TSummaryRow>
): FC<RenderProps<Cell, TRow, TSummaryRow>> => {
  const Component: FC<RenderProps<Cell, TRow, TSummaryRow>> = ({ mode, ...props }) => {
    const { onRowChange } = props
    const handleCellChange = useCallback(
      (row: TRow, cell: DefaultDataGridCells, commitChangesAndFocus?: boolean) => {
        onRowChange?.({ ...row, [props.column.key]: cell }, commitChangesAndFocus)
      },
      [onRowChange, props.column.key]
    )
    if (mode === 'edit' && renderer.Editor && props.column.editable) {
      return renderer.Editor ? (
        <renderer.Editor mode={mode} {...props} onCellChange={handleCellChange} />
      ) : (
        <renderer.View mode={mode} {...props} />
      )
    }
    return <renderer.View mode={mode} {...props} />
  }
  return Component
}
